import Vue from 'vue'

export default {
    name: 'archive',
    data() {
        return {
            title: 'Archive',
            subTitle: 'hello i am sub ',
            staticCopy :'Lorem ipsum dolor, sit amet consectetur adipisicing elit. At accusamus neque, illo velit officia aperiam magnam! Facere',
            buttonsGroup: Boolean,
            staticImage: Boolean
        }
    },

    created() {
        if(this.$breakpoints.xs || this.$breakpoints.sm) {
          Vue.nextTick(() => {
            if(this.$parent.$el != undefined) window.scroll({top: (this.$parent.$el.offsetTop - 100), left: 0, behavior: 'smooth'})
          })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/procurement-tabs/archive/archive.js